import { Injectable, signal } from '@angular/core';
import { ExtraLayerData, RouteSectionFilter } from '../interfaces/map';

@Injectable({ providedIn: 'root' })
export class RouteHighlightService {
  /** null highlights what was clicked on the map: the whole route, one segment or nothing */
  readonly sectionFilter = signal<RouteSectionFilter | null>(null);

  isActive(filter: RouteSectionFilter): boolean {
    const active = this.sectionFilter();
    return (
      !!active &&
      active.featureId === filter.featureId &&
      active.segmentTypeId === filter.segmentTypeId
    );
  }

  toggle(filter: RouteSectionFilter): void {
    this.sectionFilter.set(this.isActive(filter) ? null : filter);
  }

  clear(): void {
    this.sectionFilter.set(null);
  }

  static matches(
    extraData: ExtraLayerData | undefined,
    filter: RouteSectionFilter | null,
  ): boolean {
    if (!filter) return true;
    if (filter.featureId !== undefined) {
      return !!extraData?.routeSegmentFeatures?.some(
        (feature) => feature.RouteSegmentFeatureID === filter.featureId,
      );
    }
    return extraData?.routeSegmentTypeId === filter.segmentTypeId;
  }
}
